import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import Bookings from "./pages/Bookings";
import EditBooking from "./pages/EditBooking";
import Payments from "./pages/Payments";
import EditPayment from "./pages/EditPayment";
import Customers from "./pages/Customers";
import EditCustomer from "./pages/EditCustomer";
import Profile from "./pages/Profile";
import EditUser from "./pages/EditUser";
import Reports from "./pages/Reports";
import Registry from "./pages/Registry";
import EditRegistry from "./pages/EditRegistry";
import Properties from "./pages/Properties";
import EditProperty from "./pages/EditProperty";
import ViewBooking from "./pages/ViewBooking";
import UnconfirmPayments from "./pages/UnconfirmPayments";
import ConfirmPayment from "./pages/ConfirmPayment";
import Units from "./pages/Units";
import EditUnit from "./pages/EditUnit";
import ReportDetail from "./pages/ReportDetail";
import ViewPayment from "./pages/ViewPayment";
import Cheques from "./pages/Cheques";
import EditCheque from "./pages/EditCheque";
import Demands from "./pages/Demands";
import ViewDemand from "./pages/ViewDemand";
import CreateBooking from "./pages/CreateBooking";
import CreatePayment from "./pages/CreatePayment";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login Page */}
        <Route path="/" element={<Login />} />

        {/* Dashboard Layout (Protected Area) */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="bookings" element={<Bookings />} />
          <Route path="bookings/create" element={<CreateBooking />} />
          <Route path="bookings/view" element={<ViewBooking />} />
          <Route path="bookings/edit" element={<EditBooking />} />
          <Route path="payments" element={<Payments />} />
          <Route path="payments/create" element={<CreatePayment />} />
          <Route path="payments/edit" element={<EditPayment />} />
          <Route path="payments/view" element={<ViewPayment />} />
          <Route path="unconfirm-payments" element={<UnconfirmPayments />} />
          <Route path="payments/confirm" element={<ConfirmPayment />} />
          <Route path="cheques" element={<Cheques />} />
          <Route path="cheques/edit" element={<EditCheque />} />
          <Route path="demands" element={<Demands />} />
          <Route path="demands/view" element={<ViewDemand />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/edit" element={<EditCustomer />} />
          <Route path="registry" element={<Registry />} />
          <Route path="registry/edit" element={<EditRegistry />} />
          <Route path="properties" element={<Properties />} />
          <Route path="properties/edit" element={<EditProperty />} />
          <Route path="units" element={<Units />} />
          <Route path="units/edit" element={<EditUnit />} />
          <Route path="reports" element={<Reports />} />
          <Route path="reports/detail" element={<ReportDetail />} />
          <Route path="settings" element={<Profile />} />
          <Route path="settings/edit-user" element={<EditUser />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;


